import React, { createContext, useContext, useState } from 'react'

interface FiltersTeam {
  reason: string
  seller: string
  supervisor: string
}

interface FilterContextType {
  filters: FiltersTeam
  setFilters: React.Dispatch<React.SetStateAction<FiltersTeam>>
}

const FilterContext = createContext<FilterContextType | undefined>(undefined)

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<FiltersTeam>({
    reason: '',
    seller: '',
    supervisor: '',
  })

  return <FilterContext.Provider value={{ filters, setFilters }}>{children}</FilterContext.Provider>
}

export const useFilter = (): FilterContextType => {
  const context = useContext(FilterContext)
  if (!context) {
    throw new Error('useFilter must be used within a FilterProvider')
  }
  return context
}
